import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import Project from "@/pages/Project";

export const Route = createFileRoute("/project/$id")({
  component: ProjectRoute,
});

function ProjectRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <Project />
      </Suspense>
    </PageTransition>
  );
}
